import {Matcher} from '@/lib/axiosAddTransforms'
import {
  payResponse,
  payDateResponse,
  transactionDateResponse,
  removeDash,
} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/transfer\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId, ...payloadData} = payload.data
        payload.url = `/bizs/${bizId}/transactions/transfer`
        payload.data = payloadData
        delete payload.data.bizId
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        return data.results
      },
    },
  },
  {
    test: /^\/otp\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {otpUrl} = payload.data
        payload.url = otpUrl
        return payload
      },
      response: (data) => {
        const {tranList = []} = data
        if(!data || !tranList.length) {
          return data
        }
        return otpResponse(data)
      },
    },
  },
  {
    test: /^\/otp\/?$/,
    method: 'put',
    transform: {
      request: (payload) => {
        const {otpUrl, otpValue} = payload.data
        payload.url = otpUrl
        payload.data = {otpValue}
        return payload
      },
      response: (data) => {
        const {tranList = []} = data
        if(!data || !tranList.length) {
          return data
        }
        return otpResponse(data)
      },
    },
  },
  {
    test: /^\/transfer-status\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, workflow} = payload.data
        payload.url = `/bizs/${bizId}/workflows/${workflow}`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return data.results
      },
    },
  },
  {
    test: /^\/transfer-results\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, task} = payload.data
        payload.url = `/bizs/${bizId}/tasks/${task}`
        return payload
      },
      response: (data) => {
        const {id, transferList = []} = data
        if(!data || !id || !transferList.length) {
          return data
        }
        return transferResultResponse(data)
      },
    },
  },
  {
    test: /^\/transfer-delete\/?$/,
    method: 'delete',
    transform: {
      request: (payload) => {
        const {bizId, workflow} = payload.data
        payload.url = `/bizs/${bizId}/workflows/${workflow}`
        return payload
      },
      response: (data) => {
        return data
      },
    },
  },
]

export const otpResponse = (data) => {
  const {expiredAt = '', tranList = []} = data
  const result = {
    ...data,
    expiredAt: transactionDateResponse(expiredAt),
    transferList: tranList.map((result) => otpStatusTransferListResponse(result)),
  }
  delete result.tranList
  return result
}

export const transferResultResponse = (data) => {
  const {id = '', dueDate = '', disposedAt = '', transferList = []} = data
  return {
    ...data,
    id: String(id),
    dueDate: transactionDateResponse(dueDate),
    disposedAt: transactionDateResponse(disposedAt),
    transferList: transferList.map((result) => transferResultTransferListResponse(result)),
  }
}

const otpStatusTransferListResponse = (data) => {
  return {
    inBankCode: data.inBankCd || '',
    inAccountNumber: removeDash(data.inAcctNo) || '',
    inAccountMemo: data.inAcctMemo || '',
    outAccountNumber: removeDash(data.outAcctNo) || '',
    outAccountMemo: data.outAcctMemo || '',
    transferAmount: payResponse(data.tranAmt) || 0,
    transferFee: payResponse(data.tranFee) || 0,
    receiveName: data.recvName || '',
  }
}

const transferResultTransferListResponse = (data) => {
  return {
    inBankCode: data.inBankCode || '',
    inBankName: data.inBankName || '',
    inAccountNumber: removeDash(data.inAccountNumber) || '',
    inAccountName: data.inAccountName || '',
    inAccountMemo: data.inAccountMemo || '',
    outAccountNumber: removeDash(data.outAccountNumber) || '',
    outAccountMemo: data.outAccountMemo || '',
    transferAmount: payResponse(data.transferAmount) || 0,
    transferFee: payResponse(data.transferFee) || 0,
    transferDate: payDateResponse(data.transferDate) || 0,
    transferTime: Number(data.transferTime) || 0,
    transferResultCode: data.transferResultCode || '',
    transferResultMessage: data.transferResultMessage || '',
  }
}

export default matchers
